import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';
import { capitalize } from 'lodash';
import './style.scss';

export default function Platform({ platformData }) {
    const { platform } = platformData;
    const platformNameText = capitalize(platform.replace('_', ' '));
    const wrapperClassNames = `platform ${platform.replace('_', '-')}`;
    const iconClassNames = `platform-icon ${platform}`;

    return (
        <li className={wrapperClassNames}>
            <Tooltip content={platformNameText}>
                <i className={iconClassNames} aria-hidden="true"/>
            </Tooltip>
        </li>
    );
}

Platform.propTypes = {
    platformData: PropTypes.shape({
        platform: PropTypes.string
    })
};

Platform.defaultProps = {
    platformData: {
        platform: ''
    }
};
